import { controlTeamAthletes } from './container'

export default controlTeamAthletes
